export const navigation = [
  {
    name: "Home",
    dropDownPage:{
      "Home":"/"
    }
  },
  {
    name: "About Us",
    dropDownPage:{
      "About School / College History":"/about",
      "Director's Message":"/DirectorMessage",
      "Principal's Message":"/PrincipalMessage",
      "Mission and Vision":"/vision",
      "Awards & Achievements":"/Achievement",
      "Management Committe":"/committe",
    }
  },
  {
    name: "Admission",
    dropDownPage:{
      "Admission Documents": "/admission/document",
      "Rules and Regulations":"/admission/rule",
      "Admission Councelling":"/councelling",
      "Admission Form":"/admissionform",
      "Transport Facility":"/admission/transport",
      "School /College Timings":"/SchoolTiming",
    }
    
  },
  {
    name: "People",
    dropDownPage:{
      "Teaching Staff":"/teachingstaff",
      "Non-Teaching Staff":"/nonteachingstaff",
      "Visiting Faculty":"/visitingFaculty",
      "Helping Staff":"/helpingstaff",
      "Student's Council & PTA ":"/studentCouncile",
    }
  },
  {
    name: "Academics",
    dropDownPage:{
      "Teaching Methods":"/teaching",
      "Results":"/AcademicResults",
      "Pre-Primary":"/preprimary",
      "Primary":"/primary",
      "Secondary School":"/secondary",
      "Jr. College":"/jrcollege",
    }
  },
  {
    name: "Gallery",
    dropDownPage:{
      "Events": "/GalleryMain",

    }
  },
  {
    name: "Campus Life",
    dropDownPage:{
      "Bulbul, Girl Guide, Club and Scout":"/scoutBulbulClub",
      "Field Trips":"/fieldtrip",
      "Our Infrastructure":"/infrastructure",
      "News":"/news",
      "Life @ GHK":"/lifeghk",
      "School/College Blogs":"/Blogs",
    }
  },
  {
    name: "Alumni",
    dropDownPage:{
      "Alumni": "/alumni",

    }
  },
];



